import {createAction, handleActions} from 'redux-actions';

// - Actions
export const addOrder = createAction('ORDER_ADD', order => order);
export const reset = createAction('HISTORY_RESET');

// - State
const initialState = { };

// - Reducers
export default handleActions({
  ORDER_ADD: (state, action) => {
    const order = action.payload;
    const _state = {...state};
    _state[order.orderId] = order;
    return _state;
  },
  HISTORY_RESET: (state, action) => initialState
}, initialState);

// - Selectors
export const getOrders = (state) => state.history;



// WEBPACK FOOTER //
// ./src/reducers/historyReducer.js